import moment from 'moment'

import { api } from '@/services/index'
import store from '@/store'
import { showSnackbar } from '@/components/AcessoRealtec/snackbar.js'

function getQuery(_filter) {
    let query = ''
    if (_filter.cliCodigo)
        query += `cliCodigo=${_filter.cliCodigo}`
    if (_filter.acRealRequisicaoIni)
        query += (query == '' ? '' : '&') + `acRealRequisicaoIni=${moment(_filter.acRealRequisicaoIni).format('YYYY-MM-DD')}`
    if (_filter.acRealRequisicaoFim)
        query += (query == '' ? '' : '&') + `acRealRequisicaoFim=${moment(_filter.acRealRequisicaoFim).format('YYYY-MM-DD')}`
    if (_filter.acRealSituacao < 5)
        query += (query == '' ? '' : '&') + `acRealSituacao=${_filter.acRealSituacao}`
    if (_filter.usuCodigo)
        query += (query == '' ? '' : '&') + `usuCodigo=${_filter.usuCodigo}`

    return query
}

export function getAcessoRealtecClientes() {
    store.dispatch('setAcessoRealtecLoadingClientesData', true)

    api.post('/emsweb/acessoRealtec/clientes')
        .then(_res => {
            const data = _res.data.Rows

            store.dispatch('setAcessoRealtecClientesData', data)
            store.dispatch('setAcessoRealtecLoadingClientesData', false)
        })
        .catch(_err => {
            showSnackbar({
                message: `${_err.response.data.message}`,
                color: 'error'
            })

            store.dispatch('setAcessoRealtecLoadingClientesData', false)
        })
}

export function getAcessoRealtec(_filter) {
    let query = getQuery(_filter)

    store.dispatch('setAcessoRealtecLoadingData', true)
    api.get(`/emsweb/acessoRealtec?${query}`)
        .then(_res => {
            const data = _res.data

            store.dispatch('setAcessoRealtecData', data)
            store.dispatch('setAcessoRealtecLoadingData', false)
        })
        .catch(_err => {
            showSnackbar({
                message: `${_err.response.data.message}`,
                color: 'error'
            })

            store.dispatch('setAcessoRealtecLoadingData', false)
        })
}

export function autorizaNegaAcessoRealtec(_acRealContador, _acRealSituacao, _acRealObservacao, _usuCodigo) {
    store.dispatch('setAcessoRealtecLoadingAutorizaNega', true)

    api.put(`/emsweb/acessoRealtec/autorizaNega/${_acRealContador}&${_acRealSituacao}`, {
            acRealObservacao: _acRealObservacao,
            usuCodigo: _usuCodigo
        })
        .then(_res => {
            const data = _res.data

            store.dispatch('setAcessoRealtecAutorizaNegaData', data)
            store.dispatch('setAcessoRealtecLoadingAutorizaNega', false)

            showSnackbar({
                message: 'Acesso ' + (_acRealSituacao == 1 ? 'autorizado' : 'negado') + ' com sucesso.',
                color: 'success'
            })
        })
        .catch(_err => {
            showSnackbar({
                message: `${_err.response.data.message}`,
                color: 'error'
            })

            store.dispatch('setAcessoRealtecLoadingAutorizaNega', false)
        })
}

export function encerraAcessoRealtec(_acRealContador) {
    debugger
    store.dispatch('setAcessoRealtecLoadingEncerrado', true)

    api.put(`/emsweb/acessoRealtec/encerra/${_acRealContador}`)
        .then(_res => {
            const data = _res.data

            store.dispatch('setAcessoRealtecEncerradoData', data)
            store.dispatch('setAcessoRealtecLoadingEncerrado', false)

            showSnackbar({
                message: 'Acesso encerrado com sucesso.',
                color: 'success'
            })
        })
        .catch(_err => {
            showSnackbar({
                message: `${_err.response.data.message}`,
                color: 'error'
            })

            store.dispatch('setAcessoRealtecLoadingEncerrado', false)
        })
}